import { ConfigTypesValues, type ConfigTypes } from './configTypes';

// Create the scope for the window object. This is only for typescript so we can compile the code.
declare global {
    interface Window {
        eqappsettings: any | null;
    }
}

// We need to store the excception here and only throw it if we try and access a setting. This is because the "global" scope here is run at first import.
let exception: Error | null = null;

// We need to check that all the keys are set in the window object. and that there is not any extra keys.
if (!window['eqappsettings']) {
    window['eqappsettings'] = {};
}

// Itersate over all the keys in the ConfigTypes enum and check if they are set in the window object.
// If they are not set, then set them to null.
for (const [key, value] of Object.entries(ConfigTypesValues)) {
    // Check if the key is set in the window object.
    if (!window['eqappsettings'][value]) {
        exception = new Error(`The key "${value}" is required but not set in appsettings.js`);
    }
}

// Check if the window object has any extra keys that are not in the ConfigTypes enum.
for (const [key, value] of Object.entries(window['eqappsettings'])) {
    // Check if the key is set in the window object.
    if (!ConfigTypesValues.map((x) => x.toString()).includes(key)) {
        exception = new Error(`The key "${key}" is not in the ConfigTypes enum. and is not a valid appsettings key.`);
    }
}

/**
 * Handles all the settings that are stored in the window['eqappsettings'] object.
 *
 * We use the enum types from the configTypes.ts file to ensure that we are always using the correct keys.
 *
 * @param key The key that we want to get the value for.
 * @returns The value of the key that we are looking for.
 * @throws If the key is not set in the window object, or if there is an extra key in the window object.
 */
export const GetAppsetting = (key: ConfigTypes) => {
    if (exception !== null) {
        throw exception;
    }

    return window['eqappsettings'][key];
};

/**
 * Returns the error that was thrown when trying to access the settings.
 * This is used to check if there was an error when trying to access the settings.
 * @returns The error that was thrown when trying to access the settings.
 */
export const GetAppsettingError = () => {
    return exception;
};
